import YamlPropertiesConverter from "./YamlPropertiesConverter"

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b py-4">
        <div className="container mx-auto px-4">
          <h1 className="text-xl font-bold">YAML ⟷ Properties Converter</h1>
        </div>
      </header>

      <main className="flex-1 container mx-auto py-8 px-4">
        <h2 className="text-2xl font-bold text-center mb-6">Convert between YAML and Properties formats</h2>
        <YamlPropertiesConverter />
      </main>

      <footer className="bg-white border-t py-4">
        <div className="container mx-auto px-4 text-center text-sm text-gray-600">
          <p>© {new Date().getFullYear()} YAML ⟷ Properties Converter</p>
        </div>
      </footer>
    </div>
  )
}

export default App
